import { render } from "./Footer.vue?vue&type=template&id=34ff7082"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=34ff7082&lang=scss"
script.render = render

export default script